<template>

<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 29.774 29.774" style="enable-background:new 0 0 29.774 29.774;" xml:space="preserve">
<g>
	<path style="fill:#010002;" d="M25.262,14.514c-0.045,0-0.09-0.01-0.132-0.028l-6.129-2.509c-0.137-0.057-0.225-0.19-0.22-0.336
		c0.004-0.147,0.095-0.275,0.239-0.323l6.132-2.082c0.104-0.036,0.224-0.017,0.315,0.048c0.093,0.066,0.147,0.173,0.147,0.287v4.589
		c0,0.117-0.056,0.23-0.156,0.293C25.401,14.493,25.333,14.514,25.262,14.514z"/>
	<path style="fill:#010002;" d="M2.962,16.865c1.245,0,2.311,0.771,2.745,1.854h6.396c0.438-1.086,1.5-1.854,2.739-1.854
		c1.244,0,2.31,0.771,2.744,1.854h6.48c0.356-0.896,1.144-1.569,2.104-1.781V8.974c-0.325-0.184-0.555-0.519-0.555-0.919
		c0-0.591,0.479-1.07,1.07-1.07c0.592,0,1.07,0.479,1.07,1.07c0,0.388-0.217,0.712-0.525,0.9v7.949
		c1.435,0.207,2.544,1.429,2.544,2.923c0,1.637-1.327,2.963-2.963,2.963c-1.245,0-2.312-0.77-2.745-1.854h-6.479
		c-0.438,1.088-1.5,1.854-2.744,1.854c-1.239,0-2.306-0.77-2.739-1.854H5.708c-0.438,1.088-1.5,1.854-2.745,1.854
		C1.326,22.79,0,21.464,0,19.826C-0.001,18.191,1.326,16.865,2.962,16.865z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
